(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
(() => {
  const sticky = document.querySelector('sticky-header[data-transparent="true"]');
  if (!sticky) return;
  const headerSection = document.querySelector('.section-header');
  if (!headerSection) return;
  const style = sticky.getAttribute('data-transparent-style') || 'light';
  const apply = () => {
    const atTop = (window.scrollY || 0) < 2;
    headerSection.classList.toggle('header--transparent', atTop);
    headerSection.classList.toggle('is-light', atTop && style === 'light');
    headerSection.classList.toggle('is-dark',  atTop && style === 'dark');
  };
  apply();
  window.addEventListener('scroll', apply, { passive: true });
})();

class StickyHeader extends HTMLElement {
  constructor(){ super(); }
  connectedCallback(){
    this.header = document.querySelector('.section-header');
    this.headerIsAlwaysSticky =
      this.getAttribute('data-sticky-type') === 'always' ||
      this.getAttribute('data-sticky-type') === 'reduce-logo-size';
    this.headerBounds = {};
    this.setHeaderHeight();
    window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    if (this.headerIsAlwaysSticky) this.header.classList.add('shopify-section-header-sticky');
    this.currentScrollTop = 0; this.preventReveal = false; this.predictiveSearch = this.querySelector('predictive-search');
    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);
    this.createObserver();
  }
  setHeaderHeight(){ document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`); }
  disconnectedCallback(){ this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp); window.removeEventListener('scroll', this.onScrollHandler); }
  createObserver(){ let o=new IntersectionObserver((e,t)=>{ this.headerBounds=e[0].intersectionRect; t.disconnect(); }); o.observe(this.header); }
  onScroll(){
    const y = window.pageYOffset || document.documentElement.scrollTop;
    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
    if (y > this.currentScrollTop && y > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header'); if (this.preventHide) return; requestAnimationFrame(this.hide.bind(this));
    } else if (y < this.currentScrollTop && y > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventReveal) { requestAnimationFrame(this.reveal.bind(this)); }
      else { clearTimeout(this.isScrolling); this.isScrolling = setTimeout(()=>{ this.preventReveal=false; }, 66); requestAnimationFrame(this.hide.bind(this)); }
    } else if (y <= this.headerBounds.top) {
      this.header.classList.remove('scrolled-past-header'); requestAnimationFrame(this.reset.bind(this));
    }
    this.currentScrollTop = y;
  }
  hide(){ if (this.headerIsAlwaysSticky) return; this.header.classList.add('shopify-section-header-hidden','shopify-section-header-sticky'); this.closeMenuDisclosure(); this.closeSearchModal(); }
  reveal(){ if (this.headerIsAlwaysSticky) return; this.header.classList.add('shopify-section-header-sticky','animate'); this.header.classList.remove('shopify-section-header-hidden'); }
  reset(){ if (this.headerIsAlwaysSticky) return; this.header.classList.remove('shopify-section-header-hidden','shopify-section-header-sticky','animate'); }
  closeMenuDisclosure(){ this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu'); this.disclosures.forEach(d => d.close()); }
  closeSearchModal(){ this.searchModal = this.searchModal || this.header.querySelector('details-modal'); this.searchModal.close(false); }
}
customElements.define('sticky-header', StickyHeader);

/* passage header */
(function(){
  const sec = document.querySelector('.section-header');
  if(!sec || !('IntersectionObserver' in window)) return;

  // On crée un "sentinel" juste sous le header
  const sentinel = document.createElement('div');
  sentinel.setAttribute('aria-hidden','true');
  sentinel.style.cssText = 'position:relative;height:1px;margin-top:1px;';
  sec.after(sentinel);

  // rootMargin négatif = déclencher PLUS TÔT (ex: 40px avant)
  const io = new IntersectionObserver((entries)=>{
    const e = entries[0];
    // Quand le sentinel sort du viewport => sticky ON
    if (e.isIntersecting){
      sec.classList.remove('scrolled-past-header');
    } else {
      sec.classList.add('scrolled-past-header');
    }
  }, { root: null, threshold: 0, rootMargin: '-90px 0px 0px 0px' }); // ← joue sur -20/-60

  io.observe(sentinel);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["two-col-edito-stat"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sec = document.getElementById('story-prod-{{ section.id }}');
    if (!sec) return;
    const pos = '{{ section.settings.image_position }}';
    sec.classList.toggle('story-prod--image-left',  pos === 'left');
    sec.classList.toggle('story-prod--image-right', pos === 'right');
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-hero"] && !Shopify.designMode) return;
  try {
    
  // Si aucune source ne charge (CSP, url invalide), on masque la balise video pour éviter le poster cassé
  (() => {
    const s = document.currentScript;
    const root = s.closest('.shopify-section') || document;
    const vid = root.querySelector('.video-hero__video');
    if(!vid) return;
    const t = setTimeout(()=>{
      if(vid.readyState < 1){ vid.style.display='none'; }
    }, 2500);
    vid.addEventListener('loadeddata', ()=> clearTimeout(t), { once:true });
  })();

  } catch(e) { console.error(e); }
})();
})();
